import React from "react";

import { Button, Typography, Dialog } from "@mui/material";

import { useSelector } from "react-redux";
import { evacuationService } from "client-app-core";
import { Translate } from "orion-components/i18n";

const ToggleAccountabilityDialog = ({
	procedureId,
	showConfirmDialog,
	setShowConfirmDialog,
	pendingPersonId,
	setPendingPersonId,
	pendingCheckedValue,
	setPendingCheckedValue
}) => {
	const handleConfirm = () => {
		evacuationService.sendManualAccountability(
			{
				procedureId,
				personnelId: pendingPersonId,
				isAccounted: pendingCheckedValue
			},
			err => {
				if (err) {
					console.error("Manual accountability update failed:", err);
					return;
				}
			}
		);
		setPendingPersonId(null);
		setShowConfirmDialog(false);
	};

	const handleCancel = () => {
		setShowConfirmDialog(false);
		setPendingCheckedValue(false);
		setPendingPersonId(null);
	};

	return (
		<Dialog open={showConfirmDialog} PaperProps={{ className: "toggle-accountability-dialog" }} data-testid="orion-components-shared-components-evacuation-accountability-components-toggle-accountability-dialog-dialog">
			<div className="section1" data-testid="orion-components-shared-components-evacuation-accountability-components-toggle-accountability-dialog-div">
				<Typography className="section1Child1">
					<Translate value="global.sharedComponents.evacuationAccountability.components.toggleAccountabilityDialog.title" />
				</Typography>
				<Typography className="section1Child2">
					<Translate value="global.sharedComponents.evacuationAccountability.components.toggleAccountabilityDialog.message" />
					{pendingCheckedValue ? (
						<Translate value="global.sharedComponents.evacuationAccountability.components.toggleAccountabilityDialog.accounted" />
					) : (
						<Translate value="global.sharedComponents.evacuationAccountability.components.toggleAccountabilityDialog.unaccounted" />
					)}
				</Typography>
				<div className="section2" data-testid="orion-components-shared-components-evacuation-accountability-components-toggle-accountability-dialog-div-2">
					<Button onClick={handleConfirm} className="section2Child1" data-testid="orion-components-shared-components-evacuation-accountability-components-toggle-accountability-dialog-button">
						<Translate value="global.sharedComponents.evacuationAccountability.components.toggleAccountabilityDialog.confirm" />
					</Button>
					<Button onClick={handleCancel} className="section2Child2" data-testid="orion-components-shared-components-evacuation-accountability-components-toggle-accountability-dialog-button-2">
						<Translate value="global.sharedComponents.evacuationAccountability.components.toggleAccountabilityDialog.cancel" />
					</Button>
				</div>
			</div>
		</Dialog>
	);
};

export default ToggleAccountabilityDialog;
